import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_UPLOAD_SETUP_POD_UPLOADER_PAGE: IInventoryPage = {
	'route': '/upload/upload/setup-pod-uploader',
	'title': 'Setup POD Uploader',
	'uiReference': [
		'What is the POD Uploader?',
		'The POD Uploader is a desktop application for uploading your designs to the different Print On Demand platforms. You can import designs to your design management, create listings, and then upload the designs with the uploader. Please make sure to watch the tutorials, as the uploader has to be installed and configured before usage. Click the first video and jump straight into it.',
		'Step 1: Installation',
		'Easy-peasy installation process with this video. From downloading the application till the start of the main application. Remember: Never move your original files, always start with the launcher, like in the video!',
		'Uploader - Windows',
		'Uploader - macOS',
		'Without Setup - Windows',
		'Installation Guide - macOS',
		'Step 2: Overview & Usage',
		'Here is a general overview, what FU can do for you. From the edit, to the upload and also your language settings. A small hint of all the extra functions Flying Upload offers for you!',
		'See all Tutorials',
		'See Shortcuts',
		'Excel Standard',
		'Step 3: Settings & Configuration',
		'The configuration guide below contains all information that you need to know in order to configure your templates, and settings to use Flying We highly recommend to watch go through the configuration guide before uploading.',
		'Configuration Guide',
		'Additional setup resources',
		'Start'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/upload-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/setup-pod-uploader/setup-pod-uploader.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/setup-pod-uploader/setup-pod-uploader.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/setup-pod-uploader/setup-pod-uploader.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/shared/setup-uploader/setup-uploader.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/shared/setup-uploader/setup-uploader.component.html'
	],
	'aliases': []
};
